import React from 'react';
import '../styles/blueprint.css';

/**
 * 사이트 전역 블루프린트 배경 — 콘텐츠 뒤에 고정(z-index:-1).
 * 2단 기술 그리드 + 상단 글로우 + 코너 레지스트레이션 마크.
 * 콘텐츠 페이지 래퍼를 투명 처리하면 이 배경이 비쳐 "도면 위" 느낌을 준다.
 */
export default function BlueprintBg() {
  return (
    <div className="blueprint-bg" aria-hidden="true">
      <div className="blueprint-bg__grid" />
      <div className="blueprint-bg__glow" />
      <span className="bp-corner bp-corner--tl" />
      <span className="bp-corner bp-corner--tr" />
      <span className="bp-corner bp-corner--bl" />
      <span className="bp-corner bp-corner--br" />
    </div>
  );
}
